<script lang="ts">
  import moment from "moment";
  import T from "../texts";
  import type { TicketEvent, Refund } from "../../../types/ticket";
  import { getThumbnailURL } from "../../../lib";
  import { displayInCurrency } from "../../../lib/currency";
  import OrderMessage from "./OrderMessage.svelte";
  import MessageInner from "./MessageInner.svelte";

  export let s;
  export let ticketEvent: TicketEvent;
  export let language: string;
  export let marginTop;
  export let currency: string;
  export let isLastMessage = false;
  export let accountId;

  function generateRefundSentence(refund: Refund) {
    let sentence = T(
      language,
      "Order {0} has been refunded for the following items: ",
      [refund.order_name],
    );

    sentence += refund.refund_line_items
      .map((lineItem: any) => {
        const price = (
          parseFloat(lineItem.price) - parseFloat(lineItem.total_discount)
        ).toFixed(2);
        return T(language, "{0} {1} (at {2} each)", [
          lineItem.quantity,
          lineItem.name,
          displayInCurrency(price, currency),
        ]);
      })
      .join(", ");

    return sentence;
  }
</script>

<div style={`margin-top: ${marginTop}`}>
  <div class={s.chatBubbleRow}>
    <img
      class={s.chatThumbnail}
      src={getThumbnailURL(ticketEvent.actor_id)}
      alt="Thumbnail"
    />
    <MessageInner
      {s}
      text={(ticketEvent.payload.translations || {})[language] ||
        ticketEvent.payload.text}
    />
  </div>

  {#if isLastMessage}
    <div class={s.agentSentTime} data-datetime={ticketEvent.created_at}>
      {moment(ticketEvent.created_at).fromNow()}
    </div>
  {/if}
</div>
{#if ticketEvent.payload.actions}
  {#each ticketEvent.payload.actions as action}
    {#if action.type === "refund"}
      <div class={s.actionMessage}>
        {generateRefundSentence(action.payload.refund)}
      </div>
    {/if}
  {/each}
{/if}
{#if ticketEvent.payload.order_preview}
  <OrderMessage
    {s}
    orderPreview={ticketEvent.payload.order_preview}
    {language}
    {currency}
    {accountId}
  />
{/if}
